import { render, staticRenderFns } from "./TicketsBoard.vue?vue&type=template&id=83131b88&scoped=true"
import script from "./TicketsBoard.vue?vue&type=script&lang=js"
export * from "./TicketsBoard.vue?vue&type=script&lang=js"
import style0 from "./TicketsBoard.vue?vue&type=style&index=0&id=83131b88&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83131b88",
  null
  
)

export default component.exports